import { RouteRecordRaw } from 'vue-router'

const Dashboard = () =>
  import(/* webpackChunkName: "dashboard-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'inicio',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title: 'Inicio',
      auth: {
        requiredModule: 'dashboard',
      },
    },
  },
]
